<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="signersList"
      :no-data-text="signersNoDataText"
      dense
    >
      <template v-slot:item.orden="{ item }">
        {{ signersList.indexOf(item)+1 }}
      </template>

      <template v-slot:item.email="{ item }">
        {{ item.email.length > 30 ? item.email.substring(0, item.email.indexOf('@')) : item.email }}<br>
        {{ item.email.length > 30 ? item.email.substring(item.email.indexOf('@')) : '' }}
      </template>
      <template v-slot:item.firmado="{ item }">
        <document-status :status="item.firmado ? {descripcion:'Firmado'} : {descripcion:'Pendiente'}" />
      </template>
      <template v-slot:item.actions="{ item }">
        <div>
          <signer-update
            :id="`signer_table_document__actualizar__list`+item.rfc"
            small
            :signer="item"
            @click="clickUpdate"
          ></signer-update>
          <signer-reminder
            :id="`signer_table_document__recordatorio__list`+item.rfc"
            class="mx-1"
            small 
            :signer="item"
          ></signer-reminder>
          <signer-delete
            
            :id="`signer_table_document__eliminar__list`+item.rfc"
            small
            :signer="item"
            :last="isLastSinger"
            @deleted="signerDeleted"
          ></signer-delete>        
        </div>
      </template>     
    </v-data-table>
  </v-container>
</template>

<script>
import DocumentStatus from '@/modules/documents/components/commons/DocumentStatus'
import SignerUpdate from '@/modules/signers/components/SignerUpdate'
import SignerReminder from '@/modules/signers/components/SignerReminder'
import SignerDelete from '@/modules/signers/components/SignerDelete'


import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'


export default {
  name: 'SignersTableDocument',
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    showOrden: {
      type: Boolean,
      default() {
        return false
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DocumentStatus,
    SignerUpdate,
    SignerReminder,
    SignerDelete
  },
  computed: {
    ...signersStoreData,
    signersList: {
      get() {
        return Object.assign([], this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    headers() {
      let headers = Object.assign([], this.signersHeadersEdit)
      if(!this.showOrden) {
        headers = headers.filter(h => {
          return h.value != 'orden'
        })
      }
      if(this.readonly) {
        headers = headers.filter(h => {
          return h.value != 'actions'
        })
      }
      return headers
    },
    isLastSinger(){
      let list = this.signersList.filter(s => !s.firmado)
      return list.length == 1
      }
  },
  methods: {
    ...signersStoreActions,
    clickUpdate(signer) {
      this.$emit('clickUpdate', signer)
    },
    signerDeleted(signer) {
      let newList = this.signersList.filter(s => {
        return s.id != signer.id
      })
      this.signersList = newList 
    }
 }
}
</script>
